<template>
<div class="v-spinner spinner-centrado" v-show="loading" v-if="propLoading">
    <div class="v-sync v-sync1" v-bind:style="[spinnerStyle,spinnerDelay1]">
    </div><div class="v-sync v-sync2" v-bind:style="[spinnerStyle,spinnerDelay2]">
    </div><div class="v-sync v-sync3" v-bind:style="[spinnerStyle,spinnerDelay3]">
    </div>
  </div>
  <div id="inspire" class="fuente" v-else>
    <v-toolbar class="nav" dense="">
        <v-toolbar-title class="titulo" style="color: white">
          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            style="color: #294697"
          ></v-app-bar-nav-icon>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="#294697" class="white--text" small depressed @click="logout">
          <span>NOVA</span>
          <v-icon>mdi-backburger</v-icon>
        </v-btn>
      </v-toolbar>
    <v-container fluid fill-height>
      <v-layout> 
        <v-flex xs12 sm2 md2>
          <v-navigation-drawer class=" drawer" v-model="drawer" 
            :temporary="isMobileOrTablet"
            absolute
            :overlay-opacity="0"
            :hide-overlay="true"
            dense>
            <div v-if="isMobileOrTablet" class="close-button-container">
              <v-btn
                icon
                @click="drawer = false"
                class="close-btn"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-img :src="require('../.././assets/PANTALLA-03.png')" contain>
              <div style="display: flex; justify-content: center; align-items: center; height: 250px; background-color: #294697;">
                <v-img
                  class="ma-0 pa-0"
                  :src="require('../.././assets/nova/NOMBREBLANCO.png')"
                  max-height="100"
                  contain
                ></v-img>
              </div>
              </v-img>
              <v-list dense>
                
              <div class="name">{{nombre}}</div>

                <v-list-item-group color="#294697">

                  <v-list-item>

                    <v-list-item-content style="width:144px" >
                      <v-menu
                      :nudge-width="30"
                      offset-x
                      >
                      <template v-slot:activator="{ on }">
                        <v-list-item-title v-on="on"> <v-icon>mdi-collage</v-icon> <span style="margin-left:12%">AREAS</span> </v-list-item-title>
                      </template>

                        <v-list dense>
                          <v-list-item
                            v-for="(item, i) in subMenu"
                            :key="i"
                            :to="item.link"
                            color="#294697"
                            @click="handleNavigation"
                          >
                            <v-list-item-icon>
                              <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title v-text="item.text" ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-content>

                  </v-list-item>

                  <v-list-item
                    v-for="(item, i) in items"
                    :key="i"
                    :to="item.link"
                    @click="handleNavigation"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                  @click="logout">

                    <v-list-item-icon>
                      <v-icon>mdi-power-standby</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title @click="logout"
                      >CERRAR MODULO</v-list-item-title
                    >
                    </v-list-item-content>

                  </v-list-item>

                </v-list-item-group>
              </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-main>
            <v-container>
              <router-view  to="children"/>
            </v-container>
          </v-main>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import env from "../env";
  export default {
    name: 'SyncLoader',
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      color: { 
        type: String,
        default: '#294697'
      },
      size: {
        type: String,
        default: '30px'
      },
      margin: {
        type: String,
        default: '2px'
      },
      radius: {
        type: String,
        default: '100%'
      }
    },
    data () {
      return {
        propLoading: this.loading,
        nombre: localStorage.getItem("nombre"),
        rol: localStorage.getItem("rol"),
        drawer: null,
        items: [
          { text: "USUARIOS", icon: "mdi-account", link: "/Admin/Usuarios"},  
          { text: "USUARIOS INACTIVOS", icon: "mdi-account-off", link: "/Admin/UsuariosInactivos"},
          { text: "APLICACIONES", icon: "mdi-responsive", link: "/Admin/Aplicaciones"}, 
          { text: "PERMISOS", icon: "mdi-check-network-outline", link: "/Admin/Permisos"}, 
          { text: "PUNTOS", icon: "mdi-map-marker-plus", link: "/Admin/Puntos"},   
          { text: "CONFIG. PUNTOS", icon: "mdi-cogs", link: "/Admin/ConfiguracionPuntos"},  
        ],
        subMenu: [
          { text: "AREAS", icon: "mdi-collage", link: "/Admin/Areas"},
          { text: "CARGOS", icon: "mdi-account-convert", link: "/Admin/Cargos"},     
        ],
        spinnerStyle: {
          backgroundColor: this.color,
          height: this.size,
          width: this.size,
          margin: this.margin,
          borderRadius: this.radius,
          display: 'inline-block',
          animationName: 'v-syncStretchDelay',
          animationDuration: '0.6s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'ease-in-out',
          animationFillMode: 'both'
        },
        spinnerDelay1: {
          animationDelay: '0.07s'
        },
        spinnerDelay2: {
          animationDelay: '0.14s'
        },
        spinnerDelay3: {
          animationDelay: '0.21s'
        }
      }
    },
    methods: {
      // metodo par cerrar sesión y remover los datos del localStorage
      logout() {
      this.$router.push("/user");
    },
      handleNavigation() {
        if (this.isMobileOrTablet) {
          this.drawer = false;
        }
      },
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.xs;
      },
      isTablet() {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
      },
      isMobileOrTablet() {
        return this.isMobile || this.isTablet;
      }
    },
    mounted(){
      setTimeout(() => {
        this.propLoading= false
      }, 1000.);
    },
  } 
</script>

<style>

  /* 
  Estilos de Admin
  */

.drawer {
  background: white !important;
  z-index: 1000 !important;
}

.close-button-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
}

.close-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 50%;
}

.nav{
  background-color: #000;
  background-color: #E6E6E6;
  background-image: linear-gradient(19deg, #E6E6E6 0%, #E6E6E6 100%);
}

.list  {
  color: black !important;
}

.list a i {
  color: black !important;
}

.fuente {
  font-family: "Source Sans Pro", sans-serif !important;
}

.titulo{
  margin-right: 10px;
}

.name {
  background: linear-gradient(180deg, #1D3C7F 20%, #163266 100%);
  padding: 10px 20px;
  color: #fff;
  margin-top: -8px;
  text-align: center;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.column{
  font-size: 15px !important;
  font-family: "Source Sans Pro", sans-serif !important;
}

.table{
    margin-left: 50px;
    margin-top: 10px
  }

.icon{
  border-radius: 10px !important;
  height:100px;
  width:100px;
  background-color: #294697 !important;
}

.usuario{
  margin-left: 10px;
  font-size: 20px
}

.text-field{
  border: 2px solid #111c3d; 
  padding:5px; 
  border-radius:5px;
}

.botonplus{
    box-shadow: 0 8px 19px rgba(0,0,0,0.30), 0 3px 12px rgba(0,0,0,0.22);
}
</style>